export default __webpack_public_path__ + "static/media/ic_wbnb_40.dd380c10.svg";